// Merchant Rental Item Actions Configuration
// Actions available to merchants for rent-type order items

import { 
  CheckIcon, 
  EyeIcon,
  XMarkIcon as XIcon,
  ArrowPathIcon as ReturnIcon,
  TruckIcon
} from '@heroicons/react/24/outline';

export const merchantRentalItemActions = [
  // Cancel Item - Rental (processing + pending)
  {
    id: 'cancel_rental_item_merchant',
    label: 'Cancel Item',
    type: 'secondary',
    icon: XIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'processing',
      itemStatus: 'pending',
      beforeShipment: true,
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'MerchantCancelItemModal',
      mutation: 'useCancelOrderItemMutation',
      api: 'orderItemApi'
    }
  },

  // Cancel Item - Rental (processing + processing)
  {
    id: 'cancel_rental_item_merchant_processing',
    label: 'Cancel Item',
    type: 'secondary',
    icon: XIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'processing',
      itemStatus: 'processing',
      beforeShipment: true,
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'MerchantCancelItemModal',
      mutation: 'useCancelOrderItemMutation',
      api: 'orderItemApi'
    }
  },

  // Track Shipment - Rental (shipped_to_customer + shipped)
  {
    id: 'track_rental_shipment_merchant',
    label: 'Track Shipment',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'shipped_to_customer',
      itemStatus: 'shipped',
      hasTracking: true,
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetFulfillmentGroupTrackingQuery',
      api: 'fulfillmentGroupApi'
    }
  },

  // Ship Return Label (return_in_transit_to_merchant + return_shipped)
  {
    id: 'ship_return_label_rental',
    label: 'Ship Return Label',
    type: 'primary',
    icon: TruckIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'return_in_transit_to_merchant',
      itemStatus: 'return_shipped'
    },
    action: {
      type: 'redirect',
      target: '/merchant/ship/{fulfillmentGroupId}/return-label'
    }
  },

  // Track Return Shipment (return_in_transit_to_merchant + return_shipped)
  {
    id: 'track_return_shipment_rental_merchant',
    label: 'Track Return Shipment',
    type: 'secondary',
    icon: EyeIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'return_in_transit_to_merchant',
      itemStatus: 'return_shipped',
      hasReturnTracking: true,
      multipleItemsInGroup: true
    },
    action: {
      type: 'modal',
      component: 'TrackingModal',
      query: 'useGetReturnTrackingQuery',
      api: 'orderItemApi'
    }
  },

  // Confirm Return Receipt (return_delivered_to_merchant + return_delivered)
  {
    id: 'confirm_return_receipt_rental',
    label: 'Confirm Return Receipt',
    type: 'success',
    icon: CheckIcon,
    conditions: {
      userRole: 'merchant',
      entityType: 'orderItem',
      itemType: 'rent',
      fulfillmentGroupStatus: 'return_delivered_to_merchant',
      itemStatus: 'return_delivered'
    },
    action: {
      type: 'modal',
      component: 'ConfirmReturnReceiptModal',
      // TODO: Create confirm return receipt API
      api: {
        endpoint: '/order-items/{itemId}/confirm-return-receipt',
        method: 'PUT'
      }
    }
  }
]; 